<div class="ss-days" role="group" aria-label="Start date">
  <button *ngFor="let d of days" type="button" class="ss-chip" [class.is-selected]="selectedDate === d.iso"
    [attr.aria-pressed]="selectedDate === d.iso" (click)="pickDay(d.iso)">
    {{ d.label }}
  </button>
  <button *ngIf="offStripLabel" type="button" class="ss-chip is-selected" aria-pressed="true">{{ offStripLabel }}</button>
  <span class="ss-picker-wrap">
    <button type="button" class="ss-chip" (click)="openPicker()">Pick a date</button>
    <input #datePicker class="ss-picker" type="date" tabindex="-1" aria-hidden="true"
      [value]="selectedDate" (change)="onPickerChange(datePicker.value)" />
  </span>
</div>

<div class="ss-times" #timeList role="listbox" aria-label="Start time">
  <button *ngIf="isToday" type="button" class="ss-row" role="option" [class.is-selected]="isNowSelected()"
    [attr.aria-selected]="isNowSelected()" (click)="pickNow()">
    <span class="ss-row-label">Now <span class="ss-row-sub">{{ nowSlot }}</span></span>
    <svg *ngIf="isNowSelected()" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 13L9 17L19 7" />
    </svg>
  </button>
  <button *ngFor="let slot of timeOptions" type="button" class="ss-row" role="option"
    [class.is-selected]="isSlotSelected(slot)" [attr.aria-selected]="isSlotSelected(slot)" (click)="pickTime(slot)">
    <span class="ss-row-label">{{ slot }}</span>
    <!-- Solar check-linear -->
    <svg *ngIf="isSlotSelected(slot)" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 13L9 17L19 7" />
    </svg>
  </button>
</div>
